// extracted by css-extract-rspack-plugin
var _1 = "dUEgS";
var _2 = "NLjWA";
var _3 = "s1De5";
var _4 = "ssAKK";
var _5 = "XeV7I";
var _6 = "iW_V0";
var _7 = "E3w8P";
var _8 = "MWwjW";
var _9 = "hLBV6";
export { _1 as "archiveButtonColor", _2 as "deleteButtonColor", _3 as "mailListItemIsPinned", _4 as "markAsReadButtonColor", _5 as "moveButtonColor", _6 as "pinButtonColor", _7 as "pinButtonFilledColor", _8 as "pinFilledColor", _9 as "visibilityHidden" }
